<template>
  <div>
    <div class="dd" id="nestable2">
      <draggable
        :list="collectionsWithProducts"
        class="dd-list"
        draggable=".collection"
        group="collection"
        :tag="'ol'"
      >
        <li
          class="dd-item collection"
          v-for="collection in collectionsWithProducts"
          :key="collection.id"
        >
          <div class="dd-handle" @click="collection.open = !collection.open">
            <span class="float-right open-close-icon">
              <i
                class="fa"
                :class="{
                  'fa-angle-down': collection.open == true,
                  'fa-angle-right': collection.open == false,
                }"
              ></i>
            </span>
            <span class="label label-info">
              <i class="fa fa-align-justify"></i>
            </span>
            {{ collection.name }}
          </div>
          <draggable
            :list="collection.products"
            class="dd-list"
            draggable=".products"
            :tag="'ol'"
            v-if="collection.open == true"
          >
            <li
              v-for="product in collection.products"
              :key="product.id"
              class="dd-item products"
              :class="{
                'products-disabled': product.visible == 0,
              }"
            >
              <div class="dd-handle">
                <span style="margin: 0 10px">
                  <img style="max-width: 50px" :src="product.image_url" />
                </span>

                {{ product.plum + " - " + product.name }}
              </div>
            </li>
          </draggable>
        </li>
      </draggable>
    </div>
    <div class="hr-line-dashed"></div>
    <button @click="updateSortDraggable()" class="btn btn-primary">
      Zapisz
    </button>
  </div>
</template>

<style scoped>
.label-info-product {
  background: grey;
}
.open-close-icon {
  font-size: 15px;
}
.open-close-icon i {
  padding: 0 20px;
}
.dd-handle {
  border: none !important;
}

.products-disabled {
  background: black;
  border-radius: 3px;
}

.products-disabled .dd-handle {
  opacity: 0.7;
}
</style>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'ProductSort',
  components: {
    draggable
  },
  async created() {
    await this.getData()
    this.$emit( 'loading', false )
  },
  data() {
    return {
      collectionsWithProducts: [],
      timeSort: null,
      timeSaveSort: 2000
    }
  },
  computed: {
    productsSortUrl() {
      return `vnfr/${this.$route.params.env}/products-sort/list`
    },
    saveSortProductsUrl(){
      return `vnfr/${this.$route.params.env}/products-sort/sort`
    }
  },
  methods: {
    getData() {
      this.$http
        .get( this.productsSortUrl )
        .then( resp => {
          if ( resp.data.data !== undefined ) {
            this.collectionsWithProducts = resp.data.data
          }
        } )
        .catch( err => {
          this.$toastr.error( err )
        } )
    },
    updateSortDraggable() {
      this.$emit( 'loading', true )

      const sortProductsIds = []
      this.collectionsWithProducts.forEach( collection => {
        if ( collection.products.length > 0 ) {
          collection.products.forEach( products => {
            sortProductsIds.push( products.id )
          } )
        }
      } )
      this.$http
        .put( this.saveSortProductsUrl, {
          sortIds: sortProductsIds
        } )
        .then( resp => {
          if ( resp.data.success == true ) {
            this.$toastr.success( this.$t( 'success_save' ) )
          } else {
            this.$toastr.error( this.$t( 'fail_save' ) )
          }
          this.$emit( 'loading', false )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.$emit( 'loading', false )
        } )
    }
  }
}
</script>
